import { useContext } from "react"
import qs from "qs"
import { Button } from "@headlessui/react"
import { ClipboardIcon } from "@heroicons/react/24/outline"
import { Panel } from "~/components/CommandMenu/Panel"
import { MultiContext } from "~/contexts/MultiContext"

export function Share() {
  const { queryString } = useContext(MultiContext)

  const link = `${window.location.origin}/?${qs.stringify(queryString).replace(/%5B/g, "[").replace(/%5D/g, "]")}`

  async function copyTextToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text)
    } catch (err) {
      console.error("Failed to copy text: ", err)
    }
  }

  return (
    <Panel>
      <Panel.Heading>
        <Panel.HeadingDescription>Share this page using the link below</Panel.HeadingDescription>
        <div className="flex flex-row items-center gap-2">
          <div className="flex-1 break-all rounded-md bg-gray-600/10 p-4 text-sm text-gray-500">
            {link}
          </div>
          <div>
            <Button
              onClick={() => copyTextToClipboard(link)}
              className="flex h-fit items-center gap-2 rounded-lg bg-gray-900/10 px-4 py-2 text-sm text-gray-800 transition hover:bg-gray-600/10 focus:outline-none"
            >
              <ClipboardIcon aria-hidden="true" className="-ml-0.5 size-5" />
            </Button>
          </div>
        </div>
      </Panel.Heading>
    </Panel>
  )
}
